import React, { useState } from "react";
import moment from "moment/moment";
import "moment/locale/es";

const Context = React.createContext(null);

const ContextProvider = ({ children }) => {
  const [sessionID, setSessionID] = useState("");
  const [modalError, setModalError] = useState(false);
  const [modalCase, setModalCase] = useState(0);
  const [oferta, setOferta] = useState([]);
  const [errorMsgContext, setErrorMsgContext] = useState(null);
  const [dataPageEntrega, setDataPageEntrega] = useState({});
  const [newTelNum, setNewTelnum] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showTelnum, setShowTelnum] = useState(false);
  const [dataPage, setDataPage] = useState(null);
  const [offerDataDetail, setOfferDataDetail] = useState({});
  const [offer, setOffer] =  useState({});
  const [currentOperator, setCurrentOperator] = useState({
    operatorCode: "", operatorName: "" 
  });
  const [daysCalendar, setDaysCalendar] = useState({
    lastDay: moment(), currentMonth: moment(), 
    transitDays: null, deliveryDate: null,
  });
  const [numberType, setNumberType] = useState("")
  const [nip, setSessionNip] = useState("");
  const [stores, setStores] = useState([]);

  return (
    <Context.Provider
      value={{
        oferta,
        setOferta,
        dataPage,
        setDataPage,
        dataPageEntrega,
        setDataPageEntrega,
        modalError,
        setModalError,
        modalCase,
        setModalCase,
        errorMsgContext,
        setErrorMsgContext,
        setNewTelnum,
        newTelNum,
        phoneNumber,
        setPhoneNumber,
        setShowTelnum,
        showTelnum,
        offerDataDetail,
        setOfferDataDetail,
        currentOperator,
        setCurrentOperator,
        daysCalendar,
        setDaysCalendar,
        numberType,
        setNumberType,
        sessionID,
        setSessionID,
        offer,
        setOffer,
        nip,
        setSessionNip,
        stores,
        setStores
      }}
    >
      {children}
    </Context.Provider>
  );
};

export { ContextProvider, Context };
